/* GET SINGLE SOFT SKILL COURSE */
export const TRASH_SOFTSKILLS_COURSE = "TRASH_SOFTSKILLS_COURSE"
export const TRASH_SOFTSKILLS_COURSE_SUCCESS = "TRASH_SOFTSKILLS_COURSE_SUCCESS"
export const TRASH_SOFTSKILLS_COURSE_CLEAN = "TRASH_SOFTSKILLS_COURSE_CLEAN"
export const TRASH_SOFTSKILLS_COURSE_ERROR = "TRASH_SOFTSKILLS_COURSE_ERROR"
